import React, { useState, useContext, useEffect } from 'react'

import Paper from '@material-ui/core/Paper'
import Fab from '@material-ui/core/Fab'
import { makeStyles } from '@material-ui/core/styles'

import AddIcon from '@material-ui/icons/Add'

import { auth } from '../../utils/firebase'

import {
    ViewState,
    EditingState,
    IntegratedEditing,
} from '@devexpress/dx-react-scheduler'
import { Button, ListItem } from '@material-ui/core'
import {
    Scheduler,
    WeekView,
    Appointments,
    AppointmentTooltip,
    AppointmentForm,
    Toolbar,
    DateNavigator,
    TodayButton,
    CurrentTimeIndicator,
} from '@devexpress/dx-react-scheduler-material-ui'

import _firebaseContext from '../../contexts/firebaseContext'
import _appContext from '../../contexts/appContext'

import TooltipContent from './TooltipContent'
import AppointmentBase from './AppointmentBase'

import AlertDialog from '../AlertDialog'
import CustomEditAppointmentForm from './CustomEditAppointmentForm'
import CustomAddAppointmentForm from './CustomAddAppointmentForm'

const useStyles = makeStyles((theme) => ({
    schedulerWrapper: {
        position: 'relative',
        overflow: 'hidden',
    },
    content: {
        padding: theme.spacing(3, 1),
        paddingTop: 0,
        backgroundColor: theme.palette.background.paper,
        boxSizing: 'border-box',
        width: '400px',
    },
    addButton: {
        position: 'absolute',
        bottom: theme.spacing(2),
        right: theme.spacing(3),
    },
    lens: {
        width: theme.spacing(4.5),
        height: theme.spacing(4.5),
        verticalAlign: 'super',
    },
    title: {
        ...theme.typography.h6,
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightBold,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    titleContainer: {
        paddingBottom: theme.spacing(2),
    },
    text: {
        ...theme.typography.body2,
        display: 'inline-block',
    },
    button: {
        color: theme.palette.background.default,
        padding: 0,
    },
    dateAndTitle: {
        lineHeight: 1.1,
    },
    icon: {
        verticalAlign: 'middle',
    },
    grayIcon: {
        color: theme.palette.action.active,
    },
    textCenter: {
        textAlign: 'center',
    },
    header: {
        overflow: 'hidden',
        paddingTop: theme.spacing(0.5),
    },
    closeButton: {
        float: 'right',
    },
    coverImageContainer: {
        width: '200px',
        height: '200px',
    },
    coverImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
}))

const allLanguages = 'allLanguages'

export default function StreamsScheduler() {
    const [deleteDialog, setDeleteDialog] = useState(false)
    const [addDialog, setAddDialog] = useState(false)
    const [tooltipVisible, setTooltipVisible] = useState(false)
    const [buttonOpen, setButtonOpen] = useState(false)
    const [editFormVisible, setEditFormVisible] = useState(false)
    const [appointmentMeta, setAppointmentMeta] = useState({
        target: null,
        data: {},
    })

    const [picturesFiles, setPicturesFiles] = useState({
        monday: undefined,
        tuesday: undefined,
        wednesday: undefined,
        thursday: undefined,
        friday: undefined,
        saturday: undefined,
        sunday: undefined,
    })

    const [deletedAppointment, setDeletedAppointment] = useState(null)
    const [appointmentChanges, setAppointmentChanges] = useState({})
    const [editingAppointmentId, setEditingAppointmentId] = useState(undefined)
    const [autoTracks, setAutoTracks] = useState([])

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    useEffect(() => {
        if (firebaseContext.data.fetchingState.streams) {
            appContext.startLoading()
        } else {
            appContext.endLoading()
        }
    })

    const [languageList, setlanguageList] = useState([])
    const getLanguagesList = () =>
        firebaseContext
            .getLanguages()
            .catch((e) => console.log('getLanguagesList: ', e))
    useEffect(() => {
        ;(() => {
            getLanguagesList().then((languages) =>
                setlanguageList([
                    { id: allLanguages, data: { represent: 'Все языки' } },
                    ...languages,
                ])
            )
        })()
    }, [])

    const getAutoTracks = async () => {
        const tracks = await firebaseContext.getAutoTracks()
        if (tracks.error) {
            return appContext.snackbar.showSnackbarMsg(tracks.message)
        }

        return setAutoTracks(tracks.autoRecords)
    }

    useEffect(() => {
        ;(async () => {
            appContext.startLoading()
            await firebaseContext.startStreamsListener()
            await firebaseContext.startStreamPicturesListener()
            await getAutoTracks()
            appContext.endLoading()
        })()

        return () => {
            firebaseContext.closeStreamsListener()
            firebaseContext.closeStreamPicturesListener()
        }
    }, [])

    const classes = useStyles()

    const buttonVisibility = (event) => {
        setButtonOpen(!buttonOpen)
    }

    const toggleTooltipVisibility = (event) => {
        setTooltipVisible(!tooltipVisible)
    }

    const toggleEditFormVisibility = (event) => {
        setEditFormVisible(!editFormVisible)
    }

    // const closeEditForm = event => {
    //   setEditFormVisible(false)
    // }

    const toggleAddFormVisibility = (event) => {
        setAddDialog(!addDialog)
    }

    const toggleDeleteDialog = () => {
        setDeleteDialog(!deleteDialog)
    }

    const handleDeleteAppointment = async (state) => {
        toggleDeleteDialog()
        if (!state) return

        const result = await firebaseContext.deleteStream(deletedAppointment)

        if (result.error) {
            // TODO: добавить обработку ошибки
        } else {
            setTooltipVisible(false)
            setDeleteDialog(false)
            setDeletedAppointment(null)
        }

        appContext.snackbar.showSnackbarMsg(result.message)
    }

    const onAppointmentMetaChange = ({ data, target }) => {
        setAppointmentMeta({ data, target })
    }

    const handleCommitChanges = ({ added, changed, deleted }) => {
        if (deleted !== undefined) {
            setDeletedAppointment(deleted)
            toggleDeleteDialog()
            return
        }
    }

    const Appointment = (props) => {
        return (
            <AppointmentBase
                {...props}
                toggleVisibility={toggleTooltipVisibility}
                onAppointmentMetaChange={onAppointmentMetaChange}
            />
        )
    }

    const isStreamerOwnerOrAdmin = () =>
        auth().currentUser.role === 'admin' ||
        (appointmentMeta.data.hasOwnProperty('streamer') &&
            appointmentMeta.data.streamer.uid === auth().currentUser.uid)

    const getPictureUrl = (id) => {
        return firebaseContext.data.streamPictures[id]
            ? firebaseContext.data.streamPictures[id].pictureUrl
            : ''
    }

    const renderImageSelection = (id, name) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h5 style={{ textAlign: 'left', color: 'black' }}>{name}: </h5>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginRight: '20px',
                    }}
                >
                    <p>Текущее изображение</p>
                    <div className={classes.coverImageContainer}>
                        <img
                            className={classes.coverImage}
                            src={getPictureUrl(id)}
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <p>Новое изображение</p>
                    {picturesFiles[id] && (
                        <div className={classes.coverImageContainer}>
                            <img
                                className={classes.coverImage}
                                src={URL.createObjectURL(picturesFiles[id])}
                            />
                        </div>
                    )}
                    <input
                        type="file"
                        onChange={(event) => handleAddPictureFile(id, event)}
                    />
                    {picturesFiles[id] && (
                        <>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ marginBottom: '20px' }}
                                onClick={() => handleSaveStreamPicture(id)}
                            >
                                Сохранить изображение
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => handleDeleteStreamPicture(id)}
                            >
                                Удалить изображение
                            </Button>
                        </>
                    )}
                </div>
            </div>
        </div>
    )

    const handleAddPictureFile = (id, event) => {
        const file = event.target.files[0]

        const newPicturesFiles = { ...picturesFiles }
        newPicturesFiles[id] = file

        setPicturesFiles(newPicturesFiles)
    }

    const handleSaveStreamPicture = async (id) => {
        const result = await firebaseContext.updateStreamPicture(
            id,
            picturesFiles[id]
        )
        handleDeleteStreamPicture(id)
    }

    const handleDeleteStreamPicture = (id) => {
        handleAddPictureFile(id, { target: { files: [undefined] } })
    }

    const streamStatusRepresent = (stream) => {
        if (stream.status === 'bound' && stream.auto && !stream.converted)
            return 'еще не сконвертирован'
        if (stream.status === 'bound' && stream.auto && stream.converted)
            return 'сконвертирован'
        if (stream.status === 'bound') return 'ожидает'
        if (stream.status === 'started') return 'проигрывает'
        if (stream.status === 'finished') return 'завершен'
    }
    const streamsModelRepresent = (streams) =>
        streams.map((stream) => ({
            ...stream,
            title: `${stream.title} [${streamStatusRepresent(stream)}]`,
        }))

    return (
        <>
            <Button
                variant="text"
                color="primary"
                onClick={buttonVisibility}
                style={{ marginBottom: '20px' }}
            >
                <b>{buttonOpen ? '-' : '+'} Обложки стримов</b>
            </Button>

            {buttonOpen && (
                <Paper elevation={10} style={{ marginBottom: '20px' }}>
                    <ListItem>
                        <div>
                            {renderImageSelection('monday', 'Понедельник')}
                            {renderImageSelection('tuesday', 'Вторник')}
                            {renderImageSelection('wednesday', 'Среда')}
                            {renderImageSelection('thursday', 'Четверг')}
                            {renderImageSelection('friday', 'Пятница')}
                            {renderImageSelection('saturday', 'Суббота')}
                            {renderImageSelection('sunday', 'Воскресенье')}
                        </div>
                    </ListItem>
                </Paper>
            )}

            <Paper className={classes.schedulerWrapper}>
                <Scheduler
                    data={streamsModelRepresent(firebaseContext.data.streams)}
                    height={700}
                    locale={'ru-RU'}
                >
                    <ViewState />

                    <EditingState
                        onCommitChanges={handleCommitChanges}
                        appointmentChanges={appointmentChanges}
                        onAppointmentChangesChange={setAppointmentChanges}
                        editingAppointmentId={editingAppointmentId}
                        onEditingAppointmentIdChange={setEditingAppointmentId}
                    />
                    <IntegratedEditing />

                    <WeekView />

                    <Toolbar />
                    <DateNavigator />

                    <TodayButton messages={{ today: 'Сегодня' }} />

                    <Appointments
                        appointmentComponent={(props) => (
                            <Appointment {...props} />
                        )}
                        // appointmentContentComponent={(props) => <}
                    />
                    <AppointmentTooltip
                        visible={tooltipVisible}
                        onVisibilityChange={toggleTooltipVisibility}
                        showCloseButton
                        showOpenButton={isStreamerOwnerOrAdmin()}
                        showDeleteButton={isStreamerOwnerOrAdmin()}
                        appointmentMeta={appointmentMeta}
                        onAppointmentMetaChange={onAppointmentMetaChange}
                        contentComponent={(props) => (
                            <TooltipContent {...props} />
                        )}
                    />

                    <AppointmentForm
                        visible={editFormVisible}
                        onVisibilityChange={toggleEditFormVisibility}
                        overlayComponent={(props) => (
                            <CustomEditAppointmentForm
                                {...props}
                                appointmentMeta={appointmentMeta}
                                handleClose={toggleEditFormVisibility}
                                editingAppointmentId={editingAppointmentId}
                                autoTracks={autoTracks}
                                languageList={languageList}
                            />
                        )}
                        // messages={{
                        //   detailsLabel: 'Детали стрима',
                        //   moreInformationLabel: '',
                        //   commitCommand: 'Сохранить'
                        // }}
                    />

                    <CurrentTimeIndicator
                        shadePreviousCells={true}
                        shadePreviousAppointments={true}
                    />
                </Scheduler>

                <AlertDialog
                    open={deleteDialog}
                    title="Удаление стрима"
                    text="Вы уверены, что хотите удалить стрим?"
                    handleClose={handleDeleteAppointment}
                />

                <Fab
                    color="secondary"
                    className={classes.addButton}
                    onClick={toggleAddFormVisibility}
                >
                    <AddIcon />
                </Fab>

                <CustomAddAppointmentForm
                    open={addDialog}
                    handleClose={toggleAddFormVisibility}
                    autoTracks={autoTracks}
                    languageList={languageList}
                />
            </Paper>
        </>
    )
}
